export const API_BASE_URL=process.env.REACT_APP_API_BASE_URL;
export const REACT_APP_AWS_REGION=process.env.REACT_APP_AWS_REGION;
export const REACT_APP_AWS_ACCESS_KEY_ID=process.env.REACT_APP_AWS_ACCESS_KEY_ID;
export const REACT_APP_AWS_SECRET_ACCESS_KEY=process.env.REACT_APP_AWS_SECRET_ACCESS_KEY;
export const REACT_APP_AWS_S3_BUCKET_NAME=process.env.REACT_APP_AWS_S3_BUCKET_NAME;

export const USER_DETAILS = "users"; 
export const GET_USER_TOKEN='accessToken';

export const Attendance_API_ENDPOINT = '/users';  
export const ATTENDANE_API_ENDPOINT_STUDENT_ATTENDANCE = 'student-attendance';
export const ATTENDANE_API_ENDPOINT_STUDENT_ATTENDANCE_MULTIPLE = 'student-attendance/many';


export const class_API_ENDPOINT = '/classes';
export const CLASS_API_ENDPOINT_WITH_FILTER = '/classes?filter=schoolId';

export const SECTION_API_ENDPOINT = "class-sections";
export const SECTION_API_ENDPOINT_WITH_FILTER = "class-sections/?filter=schoolId";

export const ATTENDANE_API_ENDPOINT_STUDENT_MEAL = 'meal-distributed-students';
export const ATTENDANE_API_ENDPOINT_MEAL_DISTRIBUTION='meal-distribution';

export const STUDENT_API_ENDPOINT = '/students';
export const STUDENT_API_ENDPOINT_WITH_FILTER = '/students?filter=schoolId';
export const ACADEMICYEAR_API_ENDPOINT='/academic-year';

export const REPORT_API_ENDPOINT = "/reports";
export const REPORT_SUMMARY_API_ENDPOINT = "/reports/summary";
export const REPORT_API_ENDPOINT_EXCEPTION = "/reports/fe/exceptional-meal";

export const TEACHER_API_ENDPOINT = '/users';
export const TEACHER_API_ENDPOINT_WITH_FILTER = '/users?filter=parameter';

export const TEACHER_ATTENDANCE_API_ENDPOINT='/teacher-attendance'

export const User_API_ENDPOINT = '/user-assigned-roles/with-entity/';
export const ALL_USERS_API_ENDPOINT = '/users';

export const SCHOOL_API_ENDPOINT = '/schools';
export const KITCHEN_API_ENDPOINT = '/schools/kitchen-type';
export const SCHOOL_TYPE_API_ENDPOINT = '/schools/school-type';
export const SCHOOL_LOCATION_TYPE_API_ENDPOINT = '/schools/location-type';
export const SCHOOL_AREA_TYPE_API_ENDPOINT = '/schools/area-type';

export const USER_PROFILE_IMG ='assets/img/user.png'


export const MEAL_NOT_SERVED_REASONS='meal-not-served-reasons';

export const ADMIN_STATE_ENDPOINT ='/geo-units/states'
export const ADMIN_DISTRICT_ENDPOINT ='/geo-units/districts'
export const ADMIN_BLOCK_ENDPOINT ='/geo-units/blocks'
export const ADMIN_VILLAGE_ENDPOINT ='/geo-units/villages'
export const Admin_API_ENDPOINT_WITH_FILTER = '/users';

